import {UI} from "../../../../../stem-core/ui/UIBase";

import {ChooseAddressComponent} from "./components/ChooseAddressComponent";
import {AddOrEditAddressComponent} from "./components/AddOrEditAddressComponent.jsx";

import {BasePanelPage} from "../../../PanelPage";
import {UserAddress} from "../../../../../client/state/UserAddressStore";
import {Messages} from "../../../../Messages";
import {wrapInSpinner} from "../../../../../core/ui/LoadingSpinner.jsx";
import {autoredraw} from "../../../../../stem-core/decorators/AutoRedraw";
import {FlowInputIntent} from "../../../flows/steps/BaseFlowStep.jsx";
import {Flow} from "../../../flows/Flow.js";
import {BlinkButton} from "../../../../../core/ui/Button.jsx";


@autoredraw(UserAddress)
export class AddressPanel extends BasePanelPage {
    // Whichever class getInputComponentClass answered with; both carry isValid and getAddress
    declare addressComponent: ChooseAddressComponent | AddOrEditAddressComponent;

    getDefaultOptions(options?: this["options"]) {
        return {
            ...super.getDefaultOptions(options),
            // TODO actually, should say something else
            title: () => Flow.address.inputIntent === FlowInputIntent.CHOOSE_VALUE ? Messages.chooseAddress : Messages.addNewAddress,
        };
    }

    getContinueButtonLabel() {
        return Flow.address.getContinueButtonLabel({
            [FlowInputIntent.EDIT_VALUE.toString()]: Messages.editAddress,
            [FlowInputIntent.ADD_VALUE.toString()]: Messages.addNewAddress,
        });
    }

    isContinueButtonDisabled() {
        return !(this.addressComponent?.isValid());
    }

    @wrapInSpinner
    async handleContinueButtonClick() {
        const userAddress = await this.addressComponent.getAddress();

        await Flow.address.selectValue(userAddress);
    }

    render() {
        const {styleSheet} = this;

        const AddressInputClass = Flow.address.getInputComponentClass({
            [FlowInputIntent.CHOOSE_VALUE.toString()]: ChooseAddressComponent,
            [FlowInputIntent.ADD_VALUE.toString()]: AddOrEditAddressComponent,
        });

        return [
            <AddressInputClass
                ref="addressComponent"
                onChange={() => this.redraw()}
            />,
            <BlinkButton
                ref="button"
                label={this.getContinueButtonLabel()}
                disabled={this.isContinueButtonDisabled()}
                onClick={() => this.handleContinueButtonClick()}
                className={styleSheet.actionButton}
            />,

            Flow.address.renderBackButton(),
        ]
    }

    onMount() {
        super.onMount();
        this.redraw(); // TODO @input needed for the button to not be disabled
    }
}
